
<mat-divider></mat-divider>
<table class="purchase-info">
    <ng-container *ngIf="tickets.length == 0 || tickets == null, else ticketData">
        <tr>
            <td class="key">{{'LABEL._TICKETS' | translate}}</td>
            <td class="sign">{{'PUBLIC.SIGN' | translate }}</td>
            <td class="data">{{ 'LABEL.EMPTY_LIST' | translate }} </td>
        </tr>
    </ng-container>
     <ng-template #ticketData>
        <ng-container *ngFor="let ticket of tickets; let i= index">
            <tr>
                <td class="key">{{ i == 0 ? ('LABEL._TICKETS' | translate) : '' }}</td>
                <td class="sign">{{ i == 0 ? ('PUBLIC.SIGN' | translate) : '' }}</td>
                <td class="data">
                    <span>{{getMonth(ticket.start_date)}}</span>
                    <span class="icon">
                        <mat-icon svgIcon="slash" style="margin-right: 0;"></mat-icon>
                        {{'x'}}{{ticket.num_ticket ? ticket.num_ticket : 1}}
                        <mat-icon svgIcon="slash"></mat-icon>
                    </span>
                    <span>{{ticket.total_price ? (ticket.total_price | currency) : (0 | currency)}}</span>
                </td>
            </tr>
        </ng-container>

    </ng-template>
</table>
<mat-divider></mat-divider>
<table class="purchase-info">
    <tr>
        <td class="key">{{'LABEL.TOTAL' | translate}}</td>
        <td class="sign">{{'PUBLIC.SIGN' | translate}}</td>
        <td class="data total">{{ (totalPrice | currency) || '$0' }}</td>
    </tr>
</table>
<mat-divider></mat-divider>


